import { useStaticQuery, graphql } from 'gatsby'

export function useDataFirstScreenByEn() {
    const data = useStaticQuery(graphql`
        {
            mainVideoEn: datoCmsRenshinMainVideo(locale: { eq: "en" }) {
                videoDesktop {
                    url
                    video {
                        mp4Url(res: high)
                        thumbnailUrl(format: jpg)
                    }
                }

                videoMobile {
                    url
                    video {
                        mp4Url(res: medium)
                        thumbnailUrl(format: jpg)
                    }
                }

                posterDesktop {
                    url
                }

                posterMobile {
                    url
                }
            }
        }
    `)

    return data.mainVideoEn
}
